import type { ReactElement } from 'react';

import { memo, useCallback, useState } from 'react';

import RecentlyViewed from './RecentlyViewed';
import type { ProductRecommendations as RecommendationsSchema } from '~/amplienceTypes/schemas/imported/product-recommendations-schema';

type RecentlyViewedWrapperProps = RecommendationsSchema & {
  'aria-label'?: string;
  className?: string;
};

const RecentlyViewedWrapperComponent = (props: RecentlyViewedWrapperProps): ReactElement | null => {
  const [isEmpty, setIsEmpty] = useState(false);

  const handleReady = useCallback((hasProducts: boolean) => {
    if (!hasProducts) {
      setIsEmpty(true);
    }
  }, []);

  if (isEmpty) {
    return null;
  }

  return <RecentlyViewed {...props} onReady={handleReady} />;
};

export const RecentlyViewedWrapper = memo(RecentlyViewedWrapperComponent);
